/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */
import type { InquiryDetailResponseDtoApartmentRoomCategoriesItem } from './inquiryDetailResponseDtoApartmentRoomCategoriesItem';
import type { InquiryDetailResponseDtoApartmentSubtypesItem } from './inquiryDetailResponseDtoApartmentSubtypesItem';
import type { InquiryDetailResponseDtoFurnishingTypesItem } from './inquiryDetailResponseDtoFurnishingTypesItem';
import type { InquiryDetailResponseDtoHouseSubtypesItem } from './inquiryDetailResponseDtoHouseSubtypesItem';
import type { InquiryDetailResponseDtoLandSubtypesItem } from './inquiryDetailResponseDtoLandSubtypesItem';
import type { InquiryDetailResponseDtoOtherSubtypesItem } from './inquiryDetailResponseDtoOtherSubtypesItem';
import type { InquiryDetailResponseDtoPropertyConditionTypesItem } from './inquiryDetailResponseDtoPropertyConditionTypesItem';
import type { InquiryDetailResponseDtoRecreationalSubtypesItem } from './inquiryDetailResponseDtoRecreationalSubtypesItem';

export interface InquiryDetailResponseDto {
  propertyConditionTypes: InquiryDetailResponseDtoPropertyConditionTypesItem[];
  furnishingTypes: InquiryDetailResponseDtoFurnishingTypesItem[];
  apartmentSubtypes: InquiryDetailResponseDtoApartmentSubtypesItem[];
  apartmentRoomCategories: InquiryDetailResponseDtoApartmentRoomCategoriesItem[];
  houseSubtypes: InquiryDetailResponseDtoHouseSubtypesItem[];
  recreationalSubtypes: InquiryDetailResponseDtoRecreationalSubtypesItem[];
  landSubtypes: InquiryDetailResponseDtoLandSubtypesItem[];
  otherSubtypes: InquiryDetailResponseDtoOtherSubtypesItem[];
}
